import React, { useState } from "react";

export const Calculator = () => {
  const [showCalculation, setShowCalculation] = useState(false);
  const [cuantificacion, setCuantificacion] = useState(0);

  const [formData, setFormData] = useState({
    tipoSalida: "",
    fechaInicio: "",
    fechaSalida: "",
    tipoPago: "",
    salario: "",
    diasPendientes: "",
    diasVacaciones: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setShowCalculation(true);

    const salarioDiario = calcularSalarioDiario();
    const anosAntiguedad = calcularAnosAntiguedad();
    const diasTrabajados = calcularDiasTrabajados();
    const diasVacaciones = calcularDiasVacaciones(anosAntiguedad);

    const indemnizacion =
      formData.tipoSalida === "Despido" ? salarioDiario * 90 : 0;
    const antiguedad =
      formData.tipoSalida === "Despido" || anosAntiguedad >= 5
        ? salarioDiario * 12 * anosAntiguedad
        : 0;
    const aguinaldoProporcional = ((15 * salarioDiario) / 365) * diasTrabajados;
    const vacacionesProporcionales = (diasVacaciones / 365) * diasTrabajados;
    const primaVacacional = (vacacionesProporcionales * 25) / 100;

    setCuantificacion(
      indemnizacion +
        antiguedad +
        aguinaldoProporcional +
        vacacionesProporcionales +
        primaVacacional +
        formData.diasVacaciones +
        formData.diasPendientes
    );
  };

  const calcularSalarioDiario = () => {
    switch (formData.tipoPago) {
      case "Mensual":
        return formData.salario / 30;
      case "Quincenal":
        return formData.salario / 15;
      case "Semanal":
        return formData.salario / 7;
      case "Diario":
        return formData.salario;
        default:
          return 0;
    }
  };

  const calcularDiasTrabajados = () => {
    const fecha = new Date(formData.fechaSalida);
    const inicioAnio = new Date(fecha.getFullYear(), 0, 1);

    const diferenciaTiempo = fecha - inicioAnio;
    const diasTranscurridos = Math.floor(
      diferenciaTiempo / (1000 * 60 * 60 * 24)
    );

    return diasTranscurridos + 1;
  };

  const calcularDiasVacaciones = (anosAntiguedad) => {
    if (anosAntiguedad < 1) return 0; // Si no ha cumplido un año, no tiene vacaciones

    let diasVacaciones = 12; // Base de 12 días en el primer año

    if (anosAntiguedad > 1) {
      // Aumenta 2 días por cada año hasta el 5° (máximo 20 días en esta fase)
      diasVacaciones += Math.min(20, 2 * (anosAntiguedad - 1));

      // Después del 6° año, suma 2 días cada 2 años
      if (anosAntiguedad > 6) {
        diasVacaciones += Math.floor((anosAntiguedad - 6) / 2) * 2;
      }
    }

    return diasVacaciones;
  };

  const calcularAnosAntiguedad = () => {
    const inicio = new Date(formData.fechaInicio);
    const fin = new Date(formData.fechaSalida);

    let anosAntiguedad = fin.getFullYear() - inicio.getFullYear();

    if (
      fin.getMonth() < inicio.getMonth() ||
      (fin.getMonth() === inicio.getMonth() && fin.getDate() < inicio.getDate())
    ) {
      anosAntiguedad--;
    }

    return anosAntiguedad;
  };

  const formatearNumero = (numero) => {
    return new Intl.NumberFormat("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(numero);
  };

  const formatearFecha = (fecha) => {
    return new Intl.DateTimeFormat("es-MX", {
      day: "2-digit",
      month: "long",
      year: "numeric",
    }).format(new Date(fecha));
  };

  return (
    <div id="calculator" className="text-center">
      <div className="container">
        <div className="col-md-12 ">
          <div className="section-title">
            <h2>Calcula tus prestaciones laborales</h2>
            <p>
              Obtén un cálculo preciso de tus prestaciones laborales, incluyendo
              liquidaciones, indemnizaciones y otros beneficios, para asegurarte
              de recibir lo que te corresponde por ley.
            </p>
          </div>
        </div>
        <div className="col-md-6">
          <form name="sentMessage" onSubmit={handleSubmit}>
            <div className="form-group">
              <label>¿Cómo saliste del trabajo?</label>
              <select
                name="tipoSalida"
                className="form-control"
                onChange={handleChange}
                required
              >
                <option value="">Selecciona</option>
                <option value="Reununcia">Renuncia</option>
                <option value="Despido">Despido</option>
              </select>
            </div>
            <div className="form-group">
              <label>Fecha de inicio</label>
              <input
                type="date"
                name="fechaInicio"
                className="form-control"
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-group">
              <label>Fecha de salida</label>
              <input
                type="date"
                name="fechaSalida"
                className="form-control"
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-group">
              <label>Tipo de pago</label>
              <select
                name="tipoPago"
                className="form-control"
                onChange={handleChange}
                required
              >
                <option value="">Selecciona</option>
                <option value="Mensual">Mensual</option>
                <option value="Quincenal">Quincenal</option>
                <option value="Semanal">Semanal</option>
                <option value="Diario">Diario</option>
              </select>
            </div>
            <div className="form-group">
              <label>
                Salario {formData.tipoPago && formData.tipoPago.toLowerCase()}
              </label>
              <input
                type="number"
                name="salario"
                className="form-control"
                onChange={handleChange}
                min={1}
                step={0.01}
                required
              />
            </div>
            <div className="form-group">
              <label>Días de salario pendientes</label>
              <input
                type="number"
                name="diasPendientes"
                className="form-control"
                onChange={handleChange}
                min={0}
                required
              />
            </div>
            <div className="form-group">
              <label>Días de vacaciones pendientes</label>
              <input
                type="number"
                name="diasVacaciones"
                className="form-control"
                onChange={handleChange}
                min={0}
                required
              />
            </div>
            <button type="submit" className="btn btn-custom btn-lg page-scroll">
              <i className="fa fa-solid fa-calculator"></i>
              Calcular
            </button>
          </form>
        </div>
        {showCalculation && (
          <div className="col-md-6">
            <div className="section-title">
              <h2>Resumen de la información</h2>
              <p>
                Tipo de salida: <strong>{formData.tipoSalida}</strong>
              </p>
              <p>
                Fecha de inicio: <strong>{formatearFecha(formData.fechaInicio)}</strong>
              </p>
              <p>
                Fecha de salida: <strong>{formatearFecha(formData.fechaSalida)}</strong>
              </p>
              <p>
                Tipo de pago: <strong>{formData.tipoPago}</strong>
              </p>
              <p>
                Salario {formData.tipoPago && formData.tipoPago.toLowerCase()}:{" "}
                <strong>${formatearNumero(formData.salario)}</strong>
              </p>
              <p>
                Días de salario pendientes:{" "}
                <strong>{formData.diasPendientes}</strong>
              </p>
              <p>
                Días de vacaciones pendientes:{" "}
                <strong>{formData.diasVacaciones}</strong>
              </p>
            </div>
            <div className="section-title">
              <h2>Resultado del cálculo</h2>
              <h1>${formatearNumero(cuantificacion)}</h1>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
